import React, { FC } from 'react'
import styles from 'styles/components/form.module.scss'
import { DndBreadItem, Draggable } from 'components/Dnd'
import { Item, MoveHandler } from 'types/dnd'
import { StockUnionType } from 'types/stock'
import { getBreadShortName } from 'lib/helper'

type Props = {
  items: Item[]
  firstIndex: number
  onMove: MoveHandler
  rearrange: (index: number, direction: 'prev' | 'next') => void
  page: StockUnionType
}

const DndBreadList: FC<Props> = (props) => {
  const { items, firstIndex, onMove, rearrange, page } = props

  return (
    <section className={styles.image__list}>
      {items.map((item, index) => {
        if (page === 'daily' && !item.bread.is_type_daily) return null
        if (page === 'preorder' && !item.bread.is_type_preorder) return null
        if (page === 'delivery' && !item.bread.is_type_delivery) return null
        if (item.bread.status !== 'public') return false
        return (
          <Draggable key={item.id} index={firstIndex + index} item={item} onMove={onMove}>
            <DndBreadItem
              name={getBreadShortName(item.bread)}
              imageUrl={item.bread.image_urls[0] || ''}
              index={firstIndex + index}
              rearrange={rearrange}
              totalLength={items.length}
            />
          </Draggable>
        )
      })}
    </section>
  )
}

export default DndBreadList
